const AD_LIBRARY = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js';
const filledSlots = new WeakSet();

// Asks AdSense to fill each ad slot (views/web/ads/google) in container once.
// The slots carry no inline script, so this runs for a full load and for a page
// area swapped in by client navigation alike.
export default function fillAdSlots(container) {
	const slots = [...container.querySelectorAll('ins.adsbygoogle:not([data-adsbygoogle-status])')]
		.filter((slot) => !filledSlots.has(slot));
	if(!slots.length) {
		return;
	}
	const document = container.ownerDocument;
	if(!document.querySelector('script[src*="adsbygoogle.js"]')) {
		const script = document.createElement('script');
		script.async = true;
		script.src = AD_LIBRARY;
		document.head.appendChild(script);
	}
	const window = document.defaultView;
	window.adsbygoogle = window.adsbygoogle || [];
	slots.forEach((slot) => {
		filledSlots.add(slot);
		window.adsbygoogle.push({});
	});
}
